import exhibitorsLists from "./en/exhibitorsLists";

export default {
    exhibitorsLists,
}